/**
 * Central design tokens derived from the comp|sign landing page prototype.
 * Use these instead of hardcoded hex values so the brand styling stays consistent.
 */
const tokens = {
  colors: {
    ink: "#17323f",
    brand: "#476f81",
    brandDeep: "#315667",
    mist: "#eef4f6",
    line: "#d6e2e6",
    paper: "#fbfcfc",
    white: "#ffffff",
    signal: "#efb65a",
    signalDeep: "#8c5e16",
    muted: "#60727b",
    // tinted section background (prototype "organizer" band)
    tinted: "#f5f8f8",
    // status colors kept for existing semantic usages
    success: "#3C6E39",
    error: "#E5322C"
  },
  radius: {
    small: "4px",
    medium: "14px",
    large: "22px",
    pill: "999px"
  },
  shadow: {
    soft: "0 12px 28px rgba(23, 50, 63, .07)",
    card: "0 12px 32px rgba(23, 50, 63, .08)",
    cardHover: "0 14px 28px rgba(23, 50, 63, .09)",
    strong: "0 22px 60px rgba(23, 50, 63, .12)"
  },
  layout: {
    // responsive page shell like the prototype ".shell"
    maxWidth: "1180px"
  },
  spacing: {
    sectionGap: "40px",
    cardGap: "16px"
  }
};

/**
 * Outlined pill-less button used for the hero quick navigation and
 * the "all competitions" action, mirroring the landing page prototype.
 */
export const outlineButton = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: "42px",
  padding: "9px 14px",
  color: tokens.colors.brandDeep,
  border: "1px solid " + tokens.colors.brand,
  borderRadius: tokens.radius.small,
  backgroundColor: tokens.colors.white,
  fontSize: "11px",
  fontWeight: 700,
  letterSpacing: ".04em",
  textTransform: "none"
};
export const colors = tokens.colors;
export const radius = tokens.radius;
export const shadow = tokens.shadow;
export const spacing = tokens.spacing;
export const layout = tokens.layout;

export default tokens;
